function Content3() {
    return (
        <div style={{ maxWidth: "850px" }}>
            <div className="mobileImg">
                <img
                    style={{ maxWidth: "850px", width: "100%" }}
                    src="../../../images/png/news-3.png"
                    alt="Img3"
                />
            </div>
            <div style={{ fontSize: "14px" }}>
                Foto: Palmako erakogu
            </div>
            <h1 className="title">
                UUDIS: Palmako muutis kütuse hankimise nähtavamaks ja paremini juhitavaks
            </h1>
            <div className="content">
                <div>27.07.2026</div>
                <div className="subTitle">
                    Palmako viis koostöös Turgoiliga lõpule projekti, mille eesmärk oli
                    parandada ülevaadet ettevõtte kütusevarudest ning vähendada töötajate
                    koormust kütuse hankimise korraldamisel.
                </div>
                <div>
                    Mitmes asukohas tegutseva ettevõttena seisis Palmako silmitsi väljakutsega,
                    kus kütuse olemasolu tagamine nõudis töötajate pidevat tähelepanu. Kütusemahutite
                    seisu tuli regulaarselt kontrollida ning tellimuste planeerimine põhines sageli
                    käsitsi kogutud informatsioonil. Lisaks puudus terviklik ülevaade erinevates asukohtades
                    paiknevate mahutite täituvusest ja tarbimisest.
                </div>
                <div>
                    Projekti käigus ühendati Palmako kahe asukoha kütusemahutid Turgoili süsteemiga.
                    Tänaseks on ettevõttel olemas <b>reaalajas ülevaade mahutite seisust</b> ning kogu vajalik
                    info on koondatud ühte keskkonda. Automatiseeritud lahendus viib kütuse hankimise
                    järgmisele tasemele – kui mahuti täituvus langeb etteantud piirini, algatab Turgoili
                    süsteem hanke automaatselt ning valib eelnevalt kokkulepitud tingimuste alusel
                    sobivaima pakkumise. Palmako puhul tähendab see, et kütus tellitakse <b>automaatselt
                        parima hinnaga</b>, vähendades nii halduskoormust kui ka tarneriske.
                </div>
                <div>
                    Lisaks loob süsteem eeldused teadlikumate ostuotsuste tegemiseks. Kütuse hankimine ei
                    põhine enam ainult hetkevajadusel, vaid arvesse saab võtta ka tarbimisandmeid,
                    mahutite seisu ning turuolukorda.
                </div>
                <div>
                    Palmako projekt näitab, kuidas ettevõtted liiguvad järjest enam lahenduste poole, mis aitavad
                    vähendada käsitööd, parandada tarnekindlust ning vabastada töötajad tegevustest,
                    mis ei kuulu nende põhifookuse hulka.
                </div>
                <div>
                    Turgoili jaoks on tegemist järjekordse sammuga eesmärgi suunas muuta vedelkütuste hankimine
                    ettevõtetele nähtavamaks, efektiivsemaks ja paremini juhitavaks.
                </div>
            </div>
        </div>
    );
}

export default Content3;
